import type { IconProps } from './types'

export const HelpIcon = ({ className }: IconProps) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="8.25" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M9.75 9.5C9.75 8.25736 10.7574 7.25 12 7.25C13.2426 7.25 14.25 8.25736 14.25 9.5C14.25 10.5198 13.6504 11.1939 12.75 11.75C12.15 12.1206 11.75 12.7332 11.75 13.4385V13.75"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="16.75" r="0.9" fill="currentColor" />
    </svg>
  )
}
